import {menus} from "@/utils/const";

/**
 * 获取系统菜单
 * @returns {*}
 */
export const getRoleMenus = () => {
    let user = JSON.parse(window.localStorage.getItem('user'))
    if (user) {
        return menus.filter(f=>{
            f.child = f.child.filter(item=>{
                return item.role.indexOf(user.mrole) !== -1
            })
            return f.role.indexOf(user.mrole) !== -1
        })
    } else {
        return []
    }
}
